import * as React from 'react'

import { MONTHS } from '../../constants'
import { LABELS_WIDTH, LINE_CHART_MARGINS } from './constants'
import { LineStackedBarChartProps, View } from './types'

interface Props extends Pick<LineStackedBarChartProps, 'yearKeys' | 'chartView'> {
  barWidth: number
}

export function XAxis({ barWidth, yearKeys, chartView }: Props) {
  const rightOffset = chartView === View.lines ? LINE_CHART_MARGINS.right - barWidth / 2 : 0
  return (
    <div
      className="absolute -bottom-4.5 left-0 right-0 flex justify-between border-b border-dashed border-secondary font-sans text-3xs text-muted-2"
      style={{
        paddingLeft: 0,
        paddingRight: LABELS_WIDTH + rightOffset,
      }}
    >
      {yearKeys.map((value) => {
        const year = value.substring(0, 4)
        const month = Number.parseInt(value.substring(4, 6))

        return (
          <span key={value} className="text-center" style={{ width: barWidth }}>
            {month === 1 ? year.substring(2, 4) : MONTHS[month - 1]}
          </span>
        )
      })}
    </div>
  )
}
